import { FileText, Stamp } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export interface JuridicoPipe {
  id: string;
  label: string;
  description: string;
  icon: LucideIcon;
  disabled?: boolean;
}

export const JURIDICO_PIPES: JuridicoPipe[] = [
  {
    id: 'inpi',
    label: 'INPI · Marcas',
    description: 'Marcas & patentes — pipeline INPI.',
    icon: Stamp,
  },
  {
    id: 'contratos',
    label: 'Contratos',
    description: 'Contratos jurídicos — em breve.',
    icon: FileText,
    disabled: true,
  },
];

export const SITUACAO_INPI_TONE: Record<string, 'ok' | 'warn' | 'danger' | 'neutral'> = {
  Vigor: 'ok',
  Concedido: 'ok',
  Registrado: 'ok',
  Deferido: 'ok',
  Exigência: 'warn',
  Recurso: 'warn',
  Indeferido: 'danger',
  Indeferimento: 'danger',
  Arquivado: 'neutral',
};
